import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import RegisterModalContent from '@/components/DailyReportEdit/CombineRollback/RegisterModalContent.vue';
import RegisterModal from '@/components/Common/RegisterModal.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    execCombineRollback: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function exec() {
  props.execCombineRollback();
  modelValue.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    modalMaxWidth: "20%",
    width: "150px",
    title: props.title
  }, {
    content: _withCtx(() => [
      _createVNode(RegisterModalContent)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_btn, {
        class: "ma-2 bg-danger text-white",
        onClick: exec
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.dailyReports.combineRollbackForm.registerModal.exec')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})